import { cn } from '@/lib/utils'
import { useStudioLocale } from '@/i18n'
import { ChevronLeft, ChevronRight, ChevronsLeft, ChevronsRight } from 'lucide-react'

interface PaginationBarProps {
  page: number
  totalPages: number
  pageSize: number
  onPageChange: (page: number) => void
  className?: string
}

export function PaginationBar({ page, totalPages, pageSize: _pageSize, onPageChange, className }: PaginationBarProps) {
  // The four accessible names are the ONLY words this control has — it is
  // icon-only, so a screen-reader user hears these and nothing else.
  const { strings } = useStudioLocale()
  const copy = strings.businessScreens.review.pagination
  return (
    <div className={cn('flex items-center justify-center gap-2', className)}>
      <button aria-label={copy.first} disabled={page <= 1} onClick={() => onPageChange(1)} className="flex h-10 w-10 items-center justify-center rounded-lg text-muted-foreground hover:bg-accent disabled:cursor-not-allowed disabled:opacity-30"><ChevronsLeft className="h-4 w-4" /></button>
      <button aria-label={copy.previous} disabled={page <= 1} onClick={() => onPageChange(page - 1)} className="flex h-10 w-10 items-center justify-center rounded-lg text-muted-foreground hover:bg-accent disabled:cursor-not-allowed disabled:opacity-30"><ChevronLeft className="h-4 w-4" /></button>
      <span className="px-3 text-sm text-foreground font-medium">{page} / {totalPages}</span>
      <button aria-label={copy.next} disabled={page >= totalPages} onClick={() => onPageChange(page + 1)} className="flex h-10 w-10 items-center justify-center rounded-lg text-muted-foreground hover:bg-accent disabled:cursor-not-allowed disabled:opacity-30"><ChevronRight className="h-4 w-4" /></button>
      <button aria-label={copy.last} disabled={page >= totalPages} onClick={() => onPageChange(totalPages)} className="flex h-10 w-10 items-center justify-center rounded-lg text-muted-foreground hover:bg-accent disabled:cursor-not-allowed disabled:opacity-30"><ChevronsRight className="h-4 w-4" /></button>
    </div>
  )
}
